export enum SupplierDashboardFilterBy {
	all = 'ALL',
	pinned = 'PINNED',
	closingToday = 'CLOSING_TODAY',
	openToBid = 'OPEN_TO_BID',
	participating = 'PARTICIPATING',
	notParticipatedStartedToday = 'NOT_PARTICIPATING_STARTED_TODAY',
	notParticipatedStartedEarlier = 'NOT_PARTICIPATING_STARTED_EARLIER',
	lost = 'LOST',
	won = 'WON',
	ended = 'ENDED',
	closed = 'CLOSED',
}
